export const smoothScrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
};
